import axios from 'axios';
export const GET_SESSION_HISTORY = '[SESSION] GET SESSION HISTORY';
export const LOGOUT_ALL_SESSION  = '[SESSION] LOGOUT ALL SESSION';
export const LOADING_SESSION  = '[SESSION] LOADING SESSION AFTER TRYING DC => FALSE';

export const getSessionHistory = () => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
        let token = current_user['authToken'];
    const request = axios.get(process.env.REACT_APP_SERVER + '/api/profile/get-user-session-info', {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data) {
        return dispatch({
            type: GET_SESSION_HISTORY,
            data: response.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};

export function logoutAllSession() {
	return async (dispatch, getState) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];

		const config = {
			headers: { Authorization: `Token ${token}` }
		};
		const bodyParameters = {
			
		};
		
		const request = await axios.post(process.env.REACT_APP_SERVER + '/api/auth/logoutall', 
									bodyParameters,
									config                      
		)
        request.then(response => {
            console.log("logoutall", response)
            localStorage.removeItem('jwt_access_token');
            localStorage.removeItem('current_user');
            if (response.data.isError === false) window.location.href = '/login';
        })
        request.catch(function (error) {
            if (error.response) {
              // Request made and server responded
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            return dispatch({
                type: LOADING_SESSION,
            });
        
        });


		return dispatch({
			type: LOGOUT_ALL_SESSION,
		});
	}

}

